import {
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material"
import { LoadingIcon } from "components/Common/LoadingIcon"
import { useAppDispatch, useAppSelector } from "hooks"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import chapterService from "services/chapterService"
import { setChapters, setCurrentChapter } from "slices/chapterSlice"
import type { IChapter } from "types/chapterTypes"
import type { ITrainingModule } from "types/trainingModuleTypes"
import { ChapterCardMenu } from "./ChapterCardMenu"

type Props = {
  trainingModule: ITrainingModule
}

export function ChapterList({ trainingModule }: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const chapters = useAppSelector((state) => state.chapter.chapters)

  useEffect(() => {
    if (chapters.length === 0) {
      setIsLoading(true)
    }

    chapterService
      .getTrainingModuleChapters(trainingModule.id)
      .then((chapters) => {
        dispatch(setChapters(chapters))
        setIsLoading(false)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [chapters.length, dispatch, trainingModule.id])

  const handleClickChapter = (chapter: IChapter) => {
    dispatch(setCurrentChapter(chapter))
    navigate(`/chapter/${chapter.id}`)
  }

  return (
    <>
      {isLoading ? (
        <LoadingIcon />
      ) : (
        <Grid container spacing={2}>
          {chapters.map((chapter) => (
            <Grid key={chapter.id} item lg={4} md={6} xs={12}>
              <Card>
                <CardHeader
                  action={<ChapterCardMenu chapter={chapter} />}
                  title={chapter.id}
                  titleTypographyProps={{ variant: "body2" }}
                ></CardHeader>
                <CardActionArea onClick={() => handleClickChapter(chapter)}>
                  <CardMedia
                    component="img"
                    height="200"
                    image={chapter.imageUrl}
                    alt="Paella dish"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      {chapter.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {chapter.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  )
}
